import { addDays, addMinutes } from 'date-fns';
import { getWorkingDay } from './dateHelpers';

export const isNullish = (value: unknown): value is null | undefined => value === undefined || value === null;

export const prepareExternalUidForCandidate = (candidateId: number | string): string => {
  return `c_${candidateId}`;
};

export type StepInfo = {
  startOffsetMins?: number | null;
  remindersOffsetMins?: number[] | null;
  endOffsetMins?: number | null;
};

type Reminder = {
  reminderAt: Date;
};

export type Output = {
  sendAt: Date;
  endsAt: Date;
  reminders: Reminder[];
};
/** addMinutes is absolute, so a DST change moves the wall clock. Put that hour back. */
const keepWallClockAcrossOffsetChange = (base: Date, shifted: Date): Date => {
  const offsetDelta = shifted.getTimezoneOffset() - base.getTimezoneOffset();
  if (offsetDelta === 0) {
    return shifted;
  }
  return addMinutes(shifted, offsetDelta);
};

export const prepareSurveyDates = (processStep: StepInfo, addedOn: Date, forceResult = false): null | Output => {
  if (isNullish(processStep.startOffsetMins) || isNullish(processStep.endOffsetMins)) {
    return null;
  }

  const startDate = keepWallClockAcrossOffsetChange(addedOn, addMinutes(addedOn, processStep.startOffsetMins));

  if (startDate < new Date() && !forceResult) {
    return null;
  }
  const startDateInWorkingDay = getWorkingDay(startDate).workingDay;
  const reminders: { reminderAt: Date }[] = [];
  let remindersShift = 0;

  processStep.remindersOffsetMins?.forEach((reminderOffsetMins) => {
    const reminderBase = addDays(startDateInWorkingDay, remindersShift);
    const { workingDay: reminderDate, shiftInDays: reminderShift } = getWorkingDay(
      keepWallClockAcrossOffsetChange(reminderBase, addMinutes(reminderBase, reminderOffsetMins ?? 0)),
    );
    if (reminderOffsetMins) {
      reminders.push({
        reminderAt: reminderDate,
      });
      remindersShift = remindersShift + reminderShift;
    }
  });

  const endBase = addDays(startDateInWorkingDay, remindersShift);
  const endDate = getWorkingDay(
    keepWallClockAcrossOffsetChange(endBase, addMinutes(endBase, processStep.endOffsetMins)),
  ).workingDay;
  const output: Output = {
    sendAt: startDateInWorkingDay,
    endsAt: endDate,
    reminders: [],
  };

  return { ...output, reminders };
};
